(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('transaction-async-task', {
            parent: 'entity',
            url: '/transaction-async-task?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'bozorakaAdminApp.transactionAsyncTask.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/transaction-async-task/transaction-async-tasks.html',
                    controller: 'TransactionAsyncTaskController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('transactionAsyncTask');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('transaction-async-task-detail', {
            parent: 'transaction-async-task',
            url: '/transaction-async-task/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'bozorakaAdminApp.transactionAsyncTask.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/transaction-async-task/transaction-async-task-detail.html',
                    controller: 'TransactionAsyncTaskDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('transactionAsyncTask');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TransactionAsyncTask', function($stateParams, TransactionAsyncTask) {
                    return TransactionAsyncTask.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'transaction-async-task',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('transaction-async-task-detail.edit', {
            parent: 'transaction-async-task-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/transaction-async-task/transaction-async-task-dialog.html',
                    controller: 'TransactionAsyncTaskDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TransactionAsyncTask', function(TransactionAsyncTask) {
                            return TransactionAsyncTask.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('transaction-async-task.new', {
            parent: 'transaction-async-task',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/transaction-async-task/transaction-async-task-dialog.html',
                    controller: 'TransactionAsyncTaskDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                gateway: null,
                                serviceId: null,
                                method: null,
                                errorMessage: null,
                                status: null,
                                repeatTime: null,
                                nextCheckDate: null,
                                createdDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('transaction-async-task', null, { reload: 'transaction-async-task' });
                }, function() {
                    $state.go('transaction-async-task');
                });
            }]
        })
        .state('transaction-async-task.edit', {
            parent: 'transaction-async-task',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/transaction-async-task/transaction-async-task-dialog.html',
                    controller: 'TransactionAsyncTaskDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TransactionAsyncTask', function(TransactionAsyncTask) {
                            return TransactionAsyncTask.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('transaction-async-task', null, { reload: 'transaction-async-task' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('transaction-async-task.delete', {
            parent: 'transaction-async-task',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/transaction-async-task/transaction-async-task-delete-dialog.html',
                    controller: 'TransactionAsyncTaskDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TransactionAsyncTask', function(TransactionAsyncTask) {
                            return TransactionAsyncTask.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('transaction-async-task', null, { reload: 'transaction-async-task' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
